import React, { useState } from "react";
import Select, {SelectOption} from "@amzn/meridian/select";
import Textarea from "@amzn/meridian/textarea";
import {injectIntl, intlShape} from "react-intl";
import Column from "@amzn/meridian/column";
import {ISSUE_TYPE_OPTIONS, REQUEST_TYPE_OPTIONS} from "../../../utils/Constants";

function TaskResolution({ task, answerForIssuesFaced, setAnswerForIssuesFaced, answerForRequestType, setAnswerForTaskType, resolutionComments, setResolutionComments, setResolutionQuestionsAnswered, intl }) {
    const [showRequestTypeQuestion, setShowRequestTypeQuestion] = useState(false);

    const onIssuesFacedSelected = (value) => {
        setAnswerForIssuesFaced(value);
        if ((value === ISSUE_TYPE_OPTIONS.NO_PROBLEMS || value === ISSUE_TYPE_OPTIONS.PROBLEM_ALREADY_FIXED) && task.name.toLowerCase().includes("other")) {
            setShowRequestTypeQuestion(true);
        } else {
            setResolutionQuestionsAnswered(true);
            // Needed in cases where they first select No-Issues/Already Resolved, but then change it.
            setShowRequestTypeQuestion(false);
        }
    };

    return (
      <Column>
        <Select
          label={intl.formatMessage({id: "taskDetails.question.issuesFaced", defaultMessage: "Did you have any problems with this task?"})}
          value={answerForIssuesFaced}
          onChange={onIssuesFacedSelected}
          placeholder={intl.formatMessage({id: "taskDetails.question.selectAnswer", defaultMessage: "Select answer"})}
          size="medium"
        >
          <SelectOption value={ISSUE_TYPE_OPTIONS.NO_PROBLEMS} label={intl.formatMessage({id: "taskDetails.question.issuesFaced.noProblems", defaultMessage: "No"})} />
          <SelectOption value={ISSUE_TYPE_OPTIONS.PROBLEM_ALREADY_FIXED} label={intl.formatMessage({id: "taskDetails.question.issuesFaced.problemAlreadyFixed", defaultMessage: "Problem was already fixed"})} />
          <SelectOption value={ISSUE_TYPE_OPTIONS.SUBMITTED_THROUGH_WRONG_PROCESS} label={intl.formatMessage({id: "taskDetails.question.issuesFaced.submittedThroughWrongProcess", defaultMessage: "Request submitted through wrong process"})} />
          <SelectOption value={ISSUE_TYPE_OPTIONS.CREATED_BY_MISTAKE} label={intl.formatMessage({id: "taskDetails.question.issuesFaced.createdByMistake", defaultMessage: "Request created by mistake"})} />
        </Select>
        {showRequestTypeQuestion ? (
          <Select
            label={intl.formatMessage({id: "taskDetails.question.requestType", defaultMessage: "What was this request about?"})}
            value={answerForRequestType}
            onChange={e => { setAnswerForTaskType(e);  setResolutionQuestionsAnswered(true); }}
            placeholder={intl.formatMessage({id: "taskDetails.question.selectAnswer", defaultMessage: "Select answer"})}
            size="small"
          >
            <SelectOption value={REQUEST_TYPE_OPTIONS.TRASH_AND_OTHER_SAFETY_HAZARDS} label={intl.formatMessage({id: "taskDetails.question.requestType.trashAndOtherSafetyHazards", defaultMessage: "Trash and other safety hazards"})} />
            <SelectOption value={REQUEST_TYPE_OPTIONS.OVERFLOW_IN_PICK_TO_BUFFER_AREAS} label={intl.formatMessage({id: "taskDetails.question.requestType.overflowInPickToBufferAreas", defaultMessage: "Overflow in pick-to-buffer areas"})} />
            <SelectOption value={REQUEST_TYPE_OPTIONS.NEED_HELP_STOWING} label={intl.formatMessage({id: "taskDetails.question.requestType.needHelpStowing", defaultMessage: "Need help stowing"})} />
            <SelectOption value={REQUEST_TYPE_OPTIONS.PROBLEM_SOLVE_ASSISTANCE} label={intl.formatMessage({id: "taskDetails.question.requestType.problemSolveAssistance", defaultMessage: "Problem solve assistance"})} />
            <SelectOption value={REQUEST_TYPE_OPTIONS.LOW_ON_SUPPLY} label={intl.formatMessage({id: "taskDetails.question.requestType.lowOnSupply", defaultMessage: "Low on supply"})} />
            <SelectOption value={REQUEST_TYPE_OPTIONS.SOMETHING_ELSE} label={intl.formatMessage({id: "taskDetails.question.requestType.somethingElse", defaultMessage: "Something else"})} />
          </Select>
            ) : null}
        <Textarea
          value={resolutionComments}
          onChange={setResolutionComments}
          placeholder={intl.formatMessage({id: "taskDetails.resolution.addComment", defaultMessage: "Add Comment"})}
          label={intl.formatMessage({id: "taskDetails.resolution.comments", defaultMessage: "Comments (optional)"})}
          error={false}
          constraintText="1000 characters max"
        />
      </Column>
    );
}

TaskResolution.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(TaskResolution);



// WEBPACK FOOTER //
// ./src/components/taskExecution/resolution/TaskResolution.jsx